import { environment } from '@environments/environment'
import { UserRolesEnum } from '@ui-core/enums/user-roles.enum'

const ENV_SUFFIX = environment.env === 'prod' ? 'Prod' : 'QA'

const FEATURE_ROLE_MAP: Record<string, UserRolesEnum> = {
    Chat_History: UserRolesEnum[`Ballance_Chat_History_${ENV_SUFFIX}` as keyof typeof UserRolesEnum],
    Health_Dashboard: UserRolesEnum[`Ballance_Health_Dashboard_${ENV_SUFFIX}` as keyof typeof UserRolesEnum],
}

export function featureRoles(...features: string[]): UserRolesEnum[] {
    return [UserRolesEnum.Ballance_Admin, ...features.map((f) => FEATURE_ROLE_MAP[f])]
}
